module.exports = __webpack_public_path__ + "media/mapv_1791549790764_59100.79699a47.mp4";